import bfiThumb from '../../assets/work-thumbnails/bfi.png'
import emochaThumb from '../../assets/work-thumbnails/emocha.png'
import sleepThumb from '../../assets/work-thumbnails/sleep.png'
import workStudyThumb from '../../assets/work-thumbnails/work-study.png'
import nectarThumb from '../../assets/work-thumbnails/nectar.png'
import spotifyThumb from '../../assets/work-thumbnails/spotify.png'


const bfiData = [
    {
        imgSrc: bfiThumb,
        workLink:'/work/bfi',
        workTitle: "Redesigining The Food Institute's Website",
        workDesc: "I led the effort of a full-scale website overhaul to match their new values and mission. Refining BFI's branding and vision to finalize the website architecture and UI design.",
        workDate:'May - Aug 2022',
        labels: ['UI Design', 'Product Design', 'Branding', 'Internship']
    }
];
    
const emochaData = [
    {
        imgSrc: emochaThumb,
        workLink:'/work/emocha',
        workTitle: "emocha Health: Product Design Internship",
        workDesc: "I conducted a design audit and established a functional design library system. Here I have documented my internship reflections. Please also note that this work is under NDA.",
        workDate:'June - Aug 2022',
        labels: ['Product Design', 'UI/UX Design', 'UX Research', 'Internship']
      }
];
    
const sleepData = [
    {
        imgSrc: sleepThumb,
        workLink:'https://lupepaniagua.notion.site/Sleep-Deprivation-Website-fc108dada34b48399343e62aae7b1b24',
        workTitle: "Sleep Deprivation Website",
        workDesc: "I designed and developed a website and a flyer for my Psychology of Sleep class project. It contains information over sleep derpivation and its effects on the body + brain.",
        workDate:'Nov 2021',
        labels: ['Archive', 'Web Development', 'UI Design', 'Graphic Design']
      }
];
    
const workStudyData = [
    {
        imgSrc: workStudyThumb,
        workLink:'https://lupepaniagua.notion.site/Work-Study-Reimagined-Website-62cae2b3e4aa4e63a7ce54c5b276749a?pvs=4',
        workTitle: "UC Berkeley's Work Study Website Reimagined",
        workDesc: "The work-study portal is an integral part of UCB student's experience. However, many students encounter issues while using it so I attempted to redesign the UI/UX and overall product for a more seamless journey.",
        workDate:'Feb - Apr 2021',
        labels: ['Archive', 'Product Design', 'UI/UX Design', 'Case Study']
      }
];

const nectarData = [
    {
        imgSrc: nectarThumb,
        workLink:'/work/nectar',
        workTitle: "Nectar App",
        workDesc: "An app that simplifies grocery shopping by allowing users to compare prices on items with your local stores.",
        workDate:'Jan - March 2022',
        labels: ['Concept', 'Product Design', 'UI/UX Design', 'Case Study']
      }
];

const spotifyData = [
    {
        imgSrc: spotifyThumb,
        workLink:'/work/spotify-miniplayer',
        workTitle: "Spotify Desktop Mini Player Concept",
        workDesc: "A fun little project where I designed a new mini player widget for Spotify that includes the lyrics. Currently under future development.",
        workDate:'Aug 2023',
        labels: ['Concept', 'Product Design', 'UI Design']
      }
];
    
export {
    bfiData,
    emochaData,
    sleepData,
    workStudyData,
    nectarData,
    spotifyData,
};
